import { render } from "./NewMessageForm.vue?vue&type=template&id=dcd72f8a&scoped=true"
import script from "./NewMessageForm.vue?vue&type=script&lang=js"
export * from "./NewMessageForm.vue?vue&type=script&lang=js"

import "./NewMessageForm.vue?vue&type=style&index=0&id=dcd72f8a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dcd72f8a"
/* hot reload */
if (module.hot) {
  script.__hmrId = "dcd72f8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dcd72f8a', script)) {
    api.reload('dcd72f8a', script)
  }
  
  module.hot.accept("./NewMessageForm.vue?vue&type=template&id=dcd72f8a&scoped=true", () => {
    api.rerender('dcd72f8a', render)
  })

}

script.__file = "src/components/forms/NewMessageForm.vue"

export default script